import React from "react";
import { twMerge } from "tailwind-merge";

export const Card = ({ children, className = "" }) => {
  return (
    <div
      className={twMerge(
        "rounded-lg border shadow-sm overflow-hidden bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100",
        className,
      )}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = "", ...props }) => {
  return (
    <div
      className={twMerge(
        "px-4 py-1.5 border-b border-gray-200 dark:border-gray-700",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardTitle = ({ children, className = "" }) => {
  return (
    <h3 className={twMerge("text-sm font-semibold", className)}>{children}</h3>
  );
};

export const CardDescription = ({ children, className = "" }) => {
  return (
    <p
      className={twMerge(
        "text-xs text-gray-500 dark:text-gray-400 mt-0.5",
        className,
      )}
    >
      {children}
    </p>
  );
};

export const CardContent = ({ children, className = "" }) => {
  return <div className={twMerge("px-4 py-2", className)}>{children}</div>;
};

export const CardFooter = ({ children, className = "" }) => {
  return (
    <div
      className={twMerge(
        "px-4 py-2 border-t border-gray-200 dark:border-gray-700",
        className,
      )}
    >
      {children}
    </div>
  );
};
